const PackagesReducer = (state, action) => {
    switch (action.type) {

        case "GET_PACKAGES_START":
            return {
                ...state,
                isFetching: true,
                error: false,
            };

        case "GET_PACKAGES_SUCCESS":
            return {
                ...state,
                packages: action.payload,
                isFetching: false,
                error: false,
                hasFetched: true,
            };

        case "GET_PACKAGES_FAILURE":
            return {
                ...state,
                isFetching: false,
                error: true,
                hasFetched: false,
            };

        case "CREATE_PACKAGES_START":
            return {
                ...state,
                isFetching: true,
                error: false,
            };

        case "CREATE_PACKAGES_SUCCESS":
            return {
                ...state,
                packages: [...state.packages, action.payload],
                isFetching: false,
                error: false,
            };

        case "CREATE_PACKAGES_FAILURE":
            return {
                ...state,
                isFetching: false,
                error: true,
            };

        case "UPDATE_PACKAGES_START":
            return {
                ...state,
                isFetching: true,
                error: false,
            };

        case "UPDATE_PACKAGES_SUCCESS":
            return {
                ...state,
                packages: state.packages.map((pkg) =>
                    pkg._id === action.payload._id
                        ? action.payload
                        : pkg
                ),
                isFetching: false,
                error: false,
            };

        case "UPDATE_PACKAGES_FAILURE":
            return {
                ...state,
                isFetching: false,
                error: true,
            };

        case "DELETE_PACKAGES_START":
            return {
                ...state,
                isFetching: true,
                error: false,
            };

        case "DELETE_PACKAGES_SUCCESS":
            return {
                ...state,
                packages: state.packages.filter(
                    (pkg) =>
                        String(pkg._id) !== String(action.payload)
                ),
                isFetching: false,
                error: false,
            };

        case "DELETE_PACKAGES_FAILURE":
            return {
                ...state,
                isFetching: false,
                error: true,
            };

        default:
            return state;
    }
};

export default PackagesReducer;